module.exports = __webpack_public_path__ + "img/red-min.00b5429c.png";